// Exports
export default {
	"fetchMoreRecipients": "fetchMoreRecipients_orIff",
	"tooltip": "tooltip_BIo0r"
};
